<script lang="ts" setup>
// Properties
const props = defineProps({
    size: {
        type: String,
        default: "text-3xl md:text-4xl",
    },
    lineHeight: {
        type: String,
        default: "md:leading-h1",
    },
});

// Data
</script>

<template>
    <h1 class="font-bold" :class="size + ' ' + lineHeight">
        <slot></slot>
    </h1>
</template>

<style scoped></style>
